import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

function EventParticipationSubmissionSuccessPage({ event }) {
    return (
        <div className="background-black d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <div className="container text-center">
                <h1 className="text-white">Inschrijving Succesvol!</h1>
                <p className="text-white">
                    Je aanmelding voor {event?.name} is succesvol ingediend.
                </p>
                <p className="text-white">
                    De organisatie zal deze zo snel mogelijk in behandeling nemen.
                </p>
                <Link to="/" className="btn btn-primary">
                    Terug naar homepage
                </Link>
            </div>
        </div>
    );
}

EventParticipationSubmissionSuccessPage.propTypes = {
    event: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default EventParticipationSubmissionSuccessPage;
